import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";
import Moment from "moment";

/** importing the sub packages */
import PackagesDrop from "./SubComponents/PakagesDropDown";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CitySuggestionsCMP from "./SubComponents/SuggetionsDrop";
import { useNavigate } from "react-router-dom";
import DatePickerInput from "./SubComponents/Date";
import TimePickerInput from "./SubComponents/Time";
import moment from "moment";
import toast from "react-hot-toast";

const LocalSearchTab = ({ tripType }) => {
    // create the popus context
    const [check, setCheck] = useState(false);


    const [selectedDate, setSelectedDate] = useState(Moment());

    let dbData = JSON.parse(localStorage.getItem('cab_listing')) || {};
    // for the swishing the one tab to another tab
    const navigator = useNavigate();
    const [Packages, setPackages] = useState({
        package_id: '',
        package: ''
    });


    const [formData, setFormData] = useState({
        from_city: "",
        from_city_id: "",
        from_state_id: "",
        from_state_name: "",
        trip_type: tripType,
        to_city: "",
        to_city_id: "",
        to_state_id: "",
        to_state_name: "",
        pickup_date: new Date() ,
        pickup_time: '',
        drop_date: "",
        package: '',
        package_id: '',
        vehicle_name: "",
        vehicle_id: ""
    });

    if (Object.entries(dbData).length < 1) {
        localStorage.setItem('cab_listing', JSON.stringify(formData))
    }

    // handle changes data 
    const HandleChanesData = (DataObject) => {
        for (let property in DataObject) {
            formData[property] = DataObject[property]
        }

        // save the formatted Data
        setFormData({
            ...formData
        })
    }
    // handle submit handle tab
    useEffect(() => {
        let GetLocalDb = JSON.parse(localStorage.getItem('cab_listing')) || {};
        if (GetLocalDb.trip_type === tripType) {
            HandleChanesData(GetLocalDb)
        }
    }, [])

    const CabSearchSubmit = (e) => {
        e.preventDefault();
        if (!formData.from_city) {
            toast.error("Please Enter the valid city")
            return;
        }
        if (!['oneway', 'local', 'airport', 'outstation'].includes(tripType)) {
            toast.error("Please select the Trip type")
            return;
        }
        if (!formData.pickup_date) {
            toast.error("Please select the valid date")
            return;
        }

        if (!formData.package) {
            toast.error("Please select the List")
            return;
        }
        if (formData.pickup_time.length < 1) {
            toast.error("Please Select the Pickup Time")
            return;
        }

        const currentMoment = moment();
        // Extract date strings for comparison in YYYY-MM-DD format
        const selectedDateStr = moment(formData.pickup_date).format('YYYY-MM-DD');
        const currentDateStr = currentMoment.format('YYYY-MM-DD');

        let selectedMoment;
        if (selectedDateStr === currentDateStr) {
            // If the selected date is today, combine the date and pickup time (e.g., "2025-03-26 5:30 PM")
            selectedMoment = moment(`${selectedDateStr} ${formData.pickup_time}`, 'YYYY-MM-DD h:mm A');
        } else {
            // For future dates, assume formData.pickup_date contains full date-time information
            selectedMoment = moment(formData.pickup_date);
        }

        // Calculate the time difference in hours (floating point)
        const timeDifference = selectedMoment.diff(currentMoment, 'hours', true);

        
        localStorage.setItem('cab_listing', JSON.stringify(formData));
        navigator('/cab-listing')
    }

    return (
        <Form onSubmit={(e) => CabSearchSubmit(e)}>
            <div className="d-flex mb-3 justify-content-between">
                <CitySuggestionsCMP handleFormatted={HandleChanesData} tripType={tripType} />
                <div className="w40 multicty flex-wrap">
                    <Form.Label>Packages</Form.Label>
                    <PackagesDrop setPackagesValues={setPackages} handleFormatted={HandleChanesData} cityName={formData} />
                </div>
                <DatePickerInput handleFormatted={HandleChanesData} setSelectedDate={setSelectedDate} tripType={tripType} setCheck={setCheck} />
                <TimePickerInput handleFormatted={HandleChanesData} selectedDateInput={selectedDate} tripType={tripType} />
            </div>
            <div className="softwbtn text-center">
                <Button variant="primary" type="submit">
                    Search Cab <img
                        src="/images/search.png"
                        alt="Search Icon"
                        title="Search"
                        loading="lazy"
                        width={20} height={20}
                        style={{ width: "revert-layer", height: "auto" }}
                    />
                </Button>
            </div>
        </Form>
    )
}


export default LocalSearchTab